import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import UserAgent from 'helpers/device';

class RefreshProjections extends Component {
    onClick(e) {
        e.preventDefault();
        this.props.dispatch(Action.do('updateSlate'));
    }

    render() {
        const {sportConfig} = this.props;

        if (!sportConfig.useIntervalUpdate() || !sportConfig.isModeMain()) {
            return null;
        }

        const buttonAttributes = {
            type: 'button',
            className: 'btn-text',
            ...(!UserAgent.isMobile() && {'data-tooltip-html': 'Refresh projections'}),
        };

        return (
            <button {...buttonAttributes} onClick={(e) => ::this.onClick(e)}>
                <i className="fa fa-refresh"></i>
                {UserAgent.isMobile() ? 'Refresh projections' : 'Refresh'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(RefreshProjections);
